module.exports = __webpack_public_path__ + "img/kalis_login_slogan.772945ce.svg";